<script lang="ts">
    import { Button, Col, Form, FormGroup, Input, Label, Row } from "sveltestrap";
    import { Cancel, HorizontalFormLayout, HorizontalMessag,Submit } from "../../../../utils/Constant/Constant";
    import Card from "../../../Core/Card.svelte"
    import data from "../../../../Data/Forms/FormLayout/FormLayout.json"
    import HorizontalFormRadio from "./HorizontalFormRadio.svelte";
    import HorizontalFormCheck from "./HorizontalFormCheck.svelte";
</script>
<Col sm="12" >
    <Card headerTitle={HorizontalFormLayout} cardHeaderprops="pb-0">
      <div slot="customheader">
        <span>{@html HorizontalMessag}</span>
      </div>
      <div slot="contentbody">
        <Form class="theme-form">
            {#each data.horizontalformdata as formItem }
                <FormGroup>
                    <Row>
                        <Col sm="3">
                            <Label class="col-form-label" for={formItem.id}>{formItem.name}</Label>
                        </Col>
                        <Col sm="9">
                            <Input id={formItem.id} type={formItem.type} placeholder={formItem.placeholder} />
                        </Col>
                    </Row>
                </FormGroup>
            {/each}
           <HorizontalFormRadio />
           <HorizontalFormCheck />
        </Form>
      </div>
      <div slot="contentfooter">
        <Button color="primary">{Submit}</Button>
        <Button color="secondary">{Cancel}</Button>
      </div>
    </Card>
</Col>